<template>
    <div>
        <div class="top-line">
            <h2>
                {{ title }}
                <i class="fa fa-plus" @click="addAction"></i>
            </h2>
            <ui5-input
                placeholder="Filteren"
                :value="search"
                @input="search = $event.target.value">
                <i slot="icon" class="fa fa-search"></i>
            </ui5-input>
        </div>
        <ui5-table>
            <ui5-table-column slot="columns" popin-text="Acties">
                <span>Acties</span>
            </ui5-table-column>
            <ui5-table-column slot="columns" popin-text="ID">
                <span>ID</span>
            </ui5-table-column>
            <ui5-table-column slot="columns" popin-text="Sleutel">
                <span>Sleutel</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                v-for="languageCode in languages"
                :key="languageCode"
                :popin-text="languageCode">
                <span>{{ languageCode }}</span>
            </ui5-table-column>
            <ui5-table-row
                v-for="group in visibleGroups"
                :key="group.profileGroupId">
                <ui5-table-cell>
                    <i
                        v-if="!!group.externalSystemId"
                        class="fa fa-link"
                        style="margin-left: 13px"></i>
                    <i
                        v-if="!group.externalSystemId"
                        class="fa fa-pencil"
                        @click="
                            $router.push(
                                '/editProfileGroup/' + group.profileGroupId
                            )
                        "></i>
                    <i
                        v-if="!group.externalSystemId"
                        style="margin-left: 13px"
                        class="fa fa-trash"
                        @click="removeProfileGroup(group.profileGroupId)"></i>
                </ui5-table-cell>

                <ui5-table-cell>{{ group.profileGroupId }}</ui5-table-cell>
                <ui5-table-cell>{{ group.name }}</ui5-table-cell>
                <ui5-table-cell
                    :key="languageCode"
                    v-for="(text, languageCode) in group.translations.name">
                    {{ text }}
                </ui5-table-cell>
            </ui5-table-row>
        </ui5-table>
    </div>
</template>

<script>
import profileApi from '../../api/profile';
import axios from 'axios';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../../dialogs';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        endpoint: {
            type: String,
            required: true,
        },
        addAction: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            search: '',
            groups: [],
            columns: [65, 40],
        };
    },
    methods: {
        removeProfileGroup(profilegroupId) {
            showConfirmDialog({
                title: 'Groep verwijderen',
                content: 'Bent u zeker dat u deze groep wilt verwijderen?',
                confirm: () => {
                    profileApi
                        .deleteGroup(profilegroupId)
                        .then(() => {
                            showInfoMessage('De groep werd verwijderd');
                            this.load();
                        })
                        .catch(() => {
                            showErrorMessage(
                                'De groep kon niet verwijderd worden'
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: 'Ja',
                cancelButton: 'Nee',
            });
        },
        load() {
            axios.post(this.endpoint).then((response) => {
                this.groups = response.data.data;
            });
        },
    },
    mounted() {
        this.load();
    },
    computed: {
        visibleGroups() {
            if (!this.groups) {
                return [];
            }
            if (!this.search) {
                return this.groups;
            }
            const search = this.search.toLowerCase();

            return this.groups.filter(
                (group) =>
                    group.name.toLowerCase().includes(search) ||
                    Object.values(group.translations.name).some((translation) =>
                        translation.toLowerCase().includes(search)
                    )
            );
        },
        columnSum() {
            return this.columns.reduce(function (a, b) {
                return a + b;
            }, 0);
        },

        languages() {
            if (!this.groups) {
                return [];
            }

            const first = this.groups[0] || null;

            if (!first) {
                return [];
            }

            return Object.keys(Object.values(first.translations)[0]);
        },
    },
};
</script>
